module.exports = __webpack_public_path__ + "static/alexander-hamilton-73b012739f274e0df1dd9e9f5a43df05.jpg";